import { IHisInformationApplicable, instanceOfIHisInformationApplicable } from "./IHisInformationApplicable";

/** HIS情報の選択画面を表示可能な項目のインターフェース */
export interface IHisInformationSelectable extends IHisInformationApplicable {
  isDialogMultiSelectable: boolean;
  selectedItems: any[]; // 登録、または一時保存までの編集中の間、選択されている項目を保持する
}

export function instanceOfIHisInformationSelectable(instance: any): instance is IHisInformationSelectable {
  return (instance != null)
    && (instance.isDialogMultiSelectable !== undefined)
    && (instance.selectedItems !== undefined)
    && instanceOfIHisInformationApplicable(instance);
}
